/**
 * What a figure somebody types into a public form may be, in integer cents.
 *
 * One definition, because both ends of the wire have to agree: the server
 * refuses what falls outside, and the page has to be able to say so before
 * anybody is sent to a card field. A second literal in the browser is a second
 * answer, free to drift from the one that actually decides.
 *
 * A ceiling is not a limit on generosity. It is what makes a mistyped amount a
 * refused payment rather than a refund the office chases.
 *
 * It bounds the GIFT and not the charge. A donor who also covers the card cost
 * is charged more than they gave, by an amount they were shown and agreed to,
 * so the ceiling is the largest figure somebody can mean to give rather than
 * the largest sum that can reach the card.
 *
 * **It bounds ONE ONE-OFF GIFT, and nothing else — do not re-apply it.** A
 * PLEDGE is undertaken rather than paid, so neither its total nor a dedication's
 * level is measured against this: the aron kodesh is pledged at what the aron
 * kodesh costs. What a pledge's plan is bounded by is each INSTALLMENT, which is
 * a single payment and follows the payment bounds below. Somebody who wants to
 * give more than the ceiling in one go is not refused either — they are offered
 * a plan, which is what makes the ceiling a guard against a typo rather than a
 * refusal to take a large gift.
 */
export const GIFT_MIN_CENTS = 100
export const GIFT_MAX_CENTS = 5_000_000

/**
 * The same guard on a member paying their own account, and it is a different
 * question from a gift: paying ahead of the balance is allowed, so the ceiling
 * answers only the typo. It stands where a year of membership, a pledge and a
 * dedication can all be settled in one payment.
 */
export const PAYMENT_MIN_CENTS = 100
export const PAYMENT_MAX_CENTS = 100_000_000

/**
 * What a PLEDGE may be, which is a typo guard and nothing more.
 *
 * It is not the gift ceiling and must never be confused with it: the ceiling
 * above asks what one card payment may carry, and a pledge carries none — it is
 * an undertaking the office turns into a charge, collected over as many
 * payments as it takes. So the bound here sits where a figure stops being a sum
 * anybody means and starts being a slipped key, and the page states it before
 * anybody fills a form rather than refusing them at the end of one.
 */
export const PLEDGE_MIN_CENTS = 100
export const PLEDGE_MAX_CENTS = 100_000_000

/** How many amounts a shul may suggest, so the row stays a row. */
export const MAX_SUGGESTED_AMOUNTS = 8
